export default {
  farm: {
    locationType: "Aina ya Mahali",
    viewLocation: "Tazama Mahali",
    Circular: "Mviringo",
    Polygon: "Poligoni",
    farmerId: "Kitambulisho cha Mkulima",
    farmAddress: "Anwani ya Mahali pa Shamba",
    farmID: "Kitambulisho cha Shamba",
    farmIdPlaceHolder: "Ingiza Kitambulisho cha Shamba",
    onTheFarm: "Shambani",
    userRoles: "Vyeo vya Mtumiaji",
    adduser: "Ongeza Mtumiaji",
    addAuser: "Ongeza Mtumiaji Mmoja",
    uploadUsers: "Pakia Watumiaji",
    addNewUser: "Ongeza Mtumiaji Mpya",
    selectDept: "Chagua Idara",
    selectRole: "Chagua Jukumu",
    editUser: "Hariri Mtumiaji",
    totalFarms: "Jumla ya Mashamba",
    NoAnimalsRegisteredForthisFarm:
      "Hakuna Wanyama walioandikishwa kwa Shamba hili",
    farmsPerPage: "Mashamba kwa Ukurasa",
    regularFarms: "Mashamba ya Kawaida",
    farmRegisteredProducts: "Bidhaa Zilizosajiliwa za Shamba",
    searchByFarmNameAndId: "Tafuta kwa Jina la Shamba na Kitambulisho",
    loadingProductsPleaseWait: "Pakia Bidhaa... Tafadhali Subiri",
    farmName: "Jina la Shamba",
    nameOfTheFarm: "Jina la Shamba",
    farmLocation: "Mahali pa Shamba",
    productName: "Jina la Bidhaa",
    stockStatus: "Hali ya Hisa",
    inStock: "Katika Hisa",
    searchByProductName: "Tafuta Kwa Jina la Bidhaa",
    productCategory: "Jamii ya Bidhaa",
    products: "Bidhaa",

    farms: "Mashamba",
    zones: "Zoni",
    registerAfarm: "Sajili Shamba",
    govtRegistry: "Usajili wa Serikali",
    cooperativeId: "Kitambulisho cha Ushirika/Umoja",
    cooperativeName: "Jina la Ushirika/Umoja",
    factory: "Kiwanda",
    farmType: "Aina ya Shamba",
    contractMating: "Mating ya Mkataba",
    customization: "Kubinafsisha",
    recordsPerpage: "Kumbukumbu kwa Ukurasa",
    restoreDefault: "Rejesha Chaguo la Awali",
    apply: "Tumia",
    CommunityName: "Jina la Jumuiya",
    corporateName: "Jina la Kibiashara",
    corporateRegistrationNum: "Nambari ya Usajili wa Kibiashara",
    corporateMailingAddress: "Anwani ya Posta ya Kibiashara",
    communityName: "Jina la Jumuiya",
    searchState:
      "Tafuta kwa Kitambulisho cha Shamba, Usajili wa Serikali, Kitambulisho cha Ushirika, Aina ya Shamba, Mating ya Mkataba",
    farmOwner: "Mmiliki wa Shamba",
    govRegistrationNo: "Nambari ya Usajili wa Serikali",
    farmInformation: "Taarifa za Shamba",
    ownershipType: "Aina ya Umiliki",
    farmLicenseInformation: "Taarifa za Leseni ya Shamba",
    licenseNumber: "Nambari ya Leseni",
    licenseExpiryDate: "Tarehe ya Kumalizika kwa Leseni",
    regulatorName: "Jina la Msimamizi",
    regulatorRepresentativeName: "Jina la Mwakilishi wa Msimamizi",
    farmLocationSize: "Mahali na Ukubwa wa Shamba",
    productionSystem: "Mfumo wa Kilimo",
    productionSystemNew: "Mfumo wa Uzalishaji",
    goals: "Malengo",
    country: "Nchi",
    state: "Jimbo",
    city: "Kijiji/Mji/Jiji",
    gpsLocation: "Mahali kwa GPS",
    latitude: "Umbali wa Latitude",
    longitude: "Umbali wa Longitude",
    farmNumber: "Namba ya Shamba",
    postal: "Kodi ya Posta/Msimbo",
    houseNumber: "Namba ya Nyumba",
    farmRegistration: "Usajili wa Shamba",
    cancel: "Ghairi",
    register: "Sajili",
    ok: "sawa",
    totalFarmSize: "Ukubwa Jumla wa Shamba",
    farmGeographicLocation: "Mahali ya Jiografia ya Shamba",
    perimeterPointLongitude: "Urefu wa Pointi za Pembetatu Longitude",
    perimeterPointLatitude: "Urefu wa Pointi za Pembetatu Latitude",
    perimeterPointLabel: "Lebo ya Pointi za Pembetatu",
    perimeterLength: "Urefu wa Pembetatu",
    farmLatitude: "Latitude ya Shamba",
    farmLongitude: "Longitude ya Shamba",
    editFarm: "Hariri Shamba",
    update: "Sasisha",
    editAfarm: "Hariri Shamba",
    nextFarm: "Shamba Ijayo",
    nameoftheFarm: "Jina la Shamba",
    addNewLocation: "Ongeza Mahali Mpya",
    registerAProduct: "Sajili Bidhaa",
    farmProducts: "Bidhaa za Shamba",
    calf: "Mwana Ng'ombe",
    steer: "Ng'ombe Mkubwa",
    heifer: "Ng'ombe Dume",
    sire: "Mzazi Dume",
    dam: "Mzazi Jike",
    registerAnAnimal: "Sajili Mnyama",
    farmAnimals: "Wanyama wa Shamba",
    farm_type: "Aina ya Shamba",
    farm_Owner: "Mmiliki wa Shamba",
    dateOfRegistration: "Tarehe ya Usajili",
    dataIsNotAvailableForThisFarm: "Data Haipatikani kwa Shamba hili",
    registerNewProduct: "Sajili Bidhaa Mpya",
    information: "Taarifa",
    licenseInfo: "Taarifa ya Leseni",
    locationInfo: "Taarifa ya Mahali",
    geoLocation: "Mahali kwa GPS",
    perimeterLengthState: "Urefu wa Pembetatu za Shamba (urefu wa ua)",
    totalFarmSizeState: "Ukubwa wa Shamba",
    productionSystemState: "Mfumo wa Uzalishaji unaoitumika kwenye Shamba",
    contractMatingState:
      "Nambari ya Programu ya Mating ya Mkataba ambayo Shamba Inashiriki.",
    ownershipTypeState: "Aina ya Umiliki",
    regulatorRepresentativeNameState:
      "Jina la mtu anayewakilisha msimamizi ambaye alitoa leseni",
    regulatorNameState: "Jina la msimamizi ambaye alitoa leseni",
    licenseExpiryDateState: "Tarehe ambayo Leseni ya Sasa Inamalizika",
    licenseNumberState: "Nambari ya Leseni iliyotolewa na Msimamizi",
    plotNumberState: "Namba ya Nyumba ya Shamba.",
    plotNumber: "Namba ya Shamba",
    streetStatement: "Jina la Barabara la Shamba.",
    cityStatement: "Jiji ambapo shamba linapatikana.",
    farmLocationAddressInfo:
      "Mahali ambapo shamba linachukua shughuli kuu ya kilimo chake.",

    provinceStateInfo: "Majimbo makuu ya utawala wa nchi au himaya.",
    cityInfo:
      "Makazi au jamii yenye msongamano wa watu au jumuiya na majengo yanayohusiana, kubwa kuliko kijiji na ndogo kuliko mji, iliyoko katika eneo la vijijini.",
    streetNumberInfo: "Namba ya Barabara",
    totalFarmSizeInfo: "Ukubwa Jumla wa Shamba ",
    areaUOMInfo: "Kipimo cha ukubwa wa shamba k.m. Hekta, Ekari n.k",
    perimeterLengthInfo: "Urefu Jumla wa Pembetatu ya Shamba ",
    permiterUOMInfo:
      "Kipimo cha urefu wa Pembetatu ya shamba k.m. Santimita, Mita n.k",

    stateStatement: "Eneo la nchi ambapo shamba linapatikana.",
    countryState: "Nchi ambayo shamba inapatikana.",
    farmStateInfo: "Anwani ya mahali ya shamba",
    perimeterPointLongitudeState: "Longitude ya Pointi moja kwenye shamba.",
    perimeterPointLatitudeState: "Latitude ya Pointi moja kwenye shamba.",
    perimeterPointLabelState: "Lebo ya Pointi.",
    farmLongitudeState: "Longitude ya Shamba.",
    farmLatitudeState: "Latitude ya Shamba.",
    deleteFarm: "Futa Shamba",
    confirmBulkDeleteFarm:
      "Una hakika unataka kufuta shamba {count} lililochaguliwa?",
    selectFarmsToDelete: "Tafadhali chagua angalau shamba moja ili kufuta.",
    bulkDeleted: "Mashamba {count} yamefutwa.",

    farmNameH: "Jina la Shamba",
    farmTypeH: "Aina ya Shamba ambapo shughuli tofauti hufanyika.",
    farmOwnerH:
      "Jina la mmiliki wa shamba (jina litakalotengenezwa kiotomatiki kwa kuingiza habari)",
    ownershipTypeH:
      "Aina ya wakulima ambao wanamiliki/kudhibiti ardhi wanayolima na wale ambao hawafanyi hivyo.",
    govtRegNumbH: "Nambari ya Usajili wa Shamba ambayo ilipewa na msimamizi",
    contractMatingH:
      "Nambari ya mpango wa mating ya mkataba ambao shamba linashiriki",
    productionSystemH: "Ni mfumo gani wa uzalishaji unaotumiwa kwenye shamba",
    cooperativeIDH: "Kitambulisho cha ushirika ambao shamba ni mwanachama wake",
    licenseNumberH:
      "Nambari ya kutambua kwenye leseni iliyotolewa na msimamizi inayoitambulisha na mmiliki.",
    licenseExpiryDateH: "Tarehe ambayo leseni ya sasa inamalizika",
    regularNameH: "Jina la msimamizi ambaye alitoa leseni",
    regularRepName: "Jina la mtu anayewakilisha msimamizi ambaye alitoa leseni",
    countryH: "Nchi ambapo shamba inapatikana.",
    stateH: "Eneo la nchi ambapo shamba linapatikana.",
    cityH: "Jiji ambapo shamba linapatikana.",
    streetH: "Jina la Barabara ya Shamba.",
    houseNumberH: "Namba ya Nyumba ya Shamba.",
    totalFarmSizeH:
      "Ukubwa wa shamba ni jumla ya ardhi ambayo kwa sasa inalimwa na shamba ikiwa ni pamoja na ardhi chini ya malisho lakini isipokuwa ardhi chini ya mimea asilia, miti au malisho.",
    farmLatitudeH:
      "Ni kipimo cha umbali kaskazini au kusini mwa Ikweta. Kinapimwa na mistari 180 ya mawazo ambayo inaunda duara kuzunguka Dunia mashariki-magharibi, sawa na Ikweta",
    farmLongitudeH:
      "Kipimo cha umbali mashariki au magharibi mwa meridiani kuu.",
    perimeterLengthH: "Urefu wa Pembetatu za Shamba (urefu wa ua)",
    perimeterPointLabelH:
      "Lebo ya Pointi. Kwa kutumia vigezo vitatu (latitude, longitude na lebo) tunaelezea pembetatu ya shamba na kila mstari ndani ya shamba.",
    perimeterPointLatH: "Latitude ya Pointi moja kwenye shamba",
    perimeterPointLongH: "Longitude ya Pointi moja kwenye shamba",
    street: "Barabara",
    registration: {
      regulatorName: "Jina la msimamizi ambaye alitoa leseni",
      perimeterPointLabel:
        "Lebo ya Pointi. Kwa kutumia vigezo vitatu (latitude, longitude na lebo) tunaelezea pembetatu ya shamba na kila mstari ndani ya shamba.",
      perimeterPointLatitude: "Latitude ya Pointi ya Pembetatu",
      perimeterPointLongitude: "Longitude ya Pointi ya Pembetatu",
      farmID: "Nambari ya Utambulisho inayotolewa kwa shamba la mifugo",
      farmName: "Jina linalotolewa kwa shamba la mifugo",
      CommunityName:
        "Jina lililopewa kwa kikundi cha watu wenye sifa au masilahi yanayofanana wanaoishi pamoja ndani ya jamii kubwa",
      farmType:
        "Aina ya shamba inaweza kuchukuliwa (kikundi) kulingana na mifugo inayolimwa na jinsi inavyolimwa",
      farmOwner: "Mtu yeyote anayemiliki au kudhibiti shughuli za shamba",
      ownershipType:
        "Aina ya wakulima ambao wanamiliki/kudhibiti shamba na wale ambao hawafanyi hivyo",
      govtRegistrationNumber:
        "Nambari inayotolewa na shirika la serikali ambapo shamba limeandikishwa",
      licenseNumber: "Nambari ya leseni iliyotolewa na msimamizi",
      licenseExpiryDate: "Siku ambayo leseni inakuwa batili kwa kutambuliwa",
      regulatorRepresentativeName: "Jina la Mwakilishi wa Msimamizi",
    },
    addFarm: "Ongeza Shamba",
    farmerFirstName: "Jina la Kwanza la Mkulima",
    farmerMiddleName: "Jina la Kati la Mkulima",
    farmerLastName: "Jina la Mwisho la Mkulima",
    iAmNotFarmer: "Mimi si Mkulima",
    certifications: "Vyeti",
    productionType: "Aina ya Uzalishaji",
    deleted: "Shamba limefutwa kwa mafanikio.",
    notDeleted: "Shamba halijafutwa.",
    farmTitleDocument: "Nyaraka za Umiliki wa Shamba",
    dropHere: "au vuta na usogeze hapa",
    technicianName: "Jina la Fundi",
    farmRegistrationId: "Kitambulisho cha Usajili wa Shamba",
    farmerRegistrationId: "Kitambulisho cha Usajili wa Mkulima",
    farmId: "Kitambulisho cha Shamba",
    farmerName: "Jina la Mkulima",
    farmOwnershipType: "Aina ya Umiliki wa Mkulima",
    farmGoals: "Malengo ya Shamba",
    farmCertifications: "Vyeti vya Shamba",
    farmInfo: "Maelezo ya Shamba",
    provinceState: "Mkoa/Jimbo",
    streetNumber: "Namba ya Barabara",
    addGeofenceForThisFarm: "Ongeza kinga kwa shamba hili",
    pleaseClickToChooseLocation: "Tafadhali bonyeza kuchagua mahali",
    address: "Anwani",
    geographicLocation: "Mahali Geografiki",
    searchLocation: "Tafuta Mahali",
    pleaseChooseOneOfTheOption: "Tafadhali chagua moja ya chaguo",
    useGeoFencingFeature: "Tumia kipengele cha kinga cha geofencing",
    uploadShapeFile: "Pakia faili ya umbo",
    uploadGeofence: "Pakia kinga ya geofence",
    upload: "Pakia",
    reports: "Ripoti",
    avocado: "Avocado",
    avocadoTrees: "Miti ya Avocado",
    addNewFarmLocation: "Ongeza Mahali Mapya ya Shamba",
    farmLocationAddress: "Anwani ya Mahali ya Shamba",
    useGeofenceTool: "Tumia Zana ya Geofence",
    geofenceIsRequiredForSatelliteReport:
      "Taarifa: Geofence inahitajika kwa Ripoti za Satelait",
    enterHere: "Ingiza hapa",
    primaryLocation: "Mahali ya Kwanza",
    secondaryLocation: "Mahali ya Pili",
    locationAndSize: "Mahali na Ukubwa",
    addNewZone: "Ongeza Eneo Jipya",
    noZoneMessage: "Hakuna Eneo limeandikishwa bado.",
    noZoneRequest:
      "Tafadhali bonyeza Ongeza Eneo Jipya ili uunda Eneo kwa Shamba hili.",
    locationZone: "Eneo la Mahali",
    editFarmLocation: "Hariri Mahali ya Shamba",
    addZone: "Ongeza Eneo",
    nameOfTheZone: "Jina la Eneo",
    zoneDetails: "Maelezo ya Eneo",
    perimeter: "Pembetatu",
    areaUnit: "Kipimo cha Eneo",
    area: "Eneo",
    zoneName: "Jina la Eneo",

    farmGeofence: "Geofence ya shamba",
    circularGeofence: "Geofence ya Mviringo",
    polygonGeofence: "Uzio wa poligoni",
    radius: "Radius",
    radiusInfo:
      "Inaeleza umbali kutoka katikati hadi kwenye ukingo wa nje wa eneo la mviringo.",
    radiusUnitInfo:
      "Inarejelea kiasi cha kawaida kinachotumiwa kama msingi wa kipimo.",
    actions: "Vitendo",
    editZone: "Hariri Eneo",
    numberOfGroups: "Idadi ya Vikundi",
    numberOfTrees: "Idadi ya Miti",
    group: "Kundi",
    groupName: "Jina la Kundi",
    numberOfAnimals: "Idadi ya Wanyama",
    status: "Hali",
    primaryGeofence: "Kinga Kuu ya Geofence",
    walkAndMeasure: "Tembea na Pima",
    clearGeofence: "Ondoa Geofence",
    deleteSelectedVertex: "Futa Kona iliyochaguliwa",
    basicInformation: "Maelezo Msingi",
    geofenceCategoryName: "Jina la Kategoria ya Geofence",
    geofenceName: "Jina la Geofence",
    farmRadius: "Mzunguko wa Shamba",
    locationDisabledMessage:
      "Mahali pako imelemazwa. Tafadhali tafuta mahali pako kutoka kwenye menyu upande wa kushoto.",
    yourDistanceIs: "Umbali wako ni",
    searchFarmName: "Tafuta kwa Jina la Shamba",
    pleaseSelectFarmType: "Tafadhali chagua aina ya Shamba",
    organic: "Kiasili",
    conventional: "Kawaida",

    selectFarmToEnableCalendarView:
      "Tafadhali chagua shamba kuwezesha mtazamo wa kalenda",
    noFarm: "Hakuna shamba lililosajiliwa bado.",
    noFarmDescription: "Tafadhali bonyeza vifungo hapa chini kuanza.",
    deforestationReports: "Ripoti za Ukataji wa Miti",

    importingNote:
      "Faili lako lililopakiwa linaendelea kuchakatwa.\nUsibonyeze kufuta, kufunga au kusasisha ukurasa huu ili kuepuka kukatizwa.",
    bulkImportNote:
      "Pakua na tumia violezo vilivyo hapa chini kuingiza mashamba kwa wingi.",
    importCompleted: "Uingizaji umekamilika",
    importantNote: "Kumbuka Muhimu",
    selectFileToUpload: "Chagua faili kupakia data",
    importantNoteDetail:
      "Tafadhali tumia violezo vilivyotolewa hapo juu kwa upakiaji wa wingi. Miundo mingine itasababisha kushindwa.",

      farmsAccessControl: "Udhibiti wa Ufikiaji wa Mashamba",
    chooseTheUserYouWantToManageFarmAccessFor: "Chagua mtumiaji (watumiaji) ambao unataka kusimamia ufikiaji wa shamba kwao.",
    selectTheFarmYouWantToManageAccessFor: "Chagua shamba ambalo unataka kusimamia ufikiaji wake.",
    proceedWithSelected: "Endelea na zilizochaguliwa",
    userRole: "Jukumu la Mtumiaji",
    userRoleInfo: "Jukumu la mtumiaji. Jukumu la mtumiaji huamua ruhusa ambazo mtumiaji ana kwenye shamba.",
    usersSelected: "watumiaji waliochaguliwa",
    viewFarmAccess: "Angalia Ufikiaji wa Shamba",
    selectUser: "Chagua Mtumiaji",
    recordsPerPage: "Rekodi kwa ukurasa",
    print: "Chapisha",
    custom: "Maalum",
    records: "Rekodi",
    dashboard: "Dashibodi",
    accessControl: "Udhibiti wa Ufikiaji",
    all: "Wote",
    farmer: "Mkulima",
    technician: "Fundi",
    userNameAndId: "Jina la Mtumiaji na Kitambulisho",
    email: "Barua pepe",
    userRoleAndRegDate: "Jukumu la Mtumiaji / Tarehe ya Usajili",
    access: "Ufikiaji",
    active: "Hai",
    inactive: "Haipo",
    na: "N/A",
    userDeactivated: "Mtumiaji Amekatizwa",
    userActivated: "Mtumiaji Ameamilishwa",
    farmUsers: "Watumiaji wa Shamba",
    viewAndUpdateTheFarmsThisUserHasAccessTo: "Angalia na sasisha mashamba ambayo mtumiaji huyu ana ufikiaji",
    assignFarmsToTheSelectedUsers: "Gawa mashamba kwa watumiaji waliochaguliwa",
    selectTheFarmsYouWantToGrantAccessToForTheChosenTechnicians: "Chagua mashamba ambayo unataka kuwapa ufikiaji kwa wafundi waliochaguliwa.",
    removeAccessFromSelectedFarms: "Ondoa Ufikiaji kutoka Mashamba yaliyochaguliwa",
    grantFarmAccess: "Ruhusu Ufikiaji wa Shamba",
    back: "Rudi",
    s: "(s)",
    loadingData: "Inapakia data...",
    areYouSureYouWantToGrantAccessTo: "Je, una uhakika unataka kutoa ufikiaji kwa",
    areYouSureYouWantToRemoveAccessFrom: "Je, una uhakika unataka kuondoa ufikiaji kutoka",
    farmAccessRemoved: "Ufikiaji wa Shamba Umeondolewa",
    successfullyRemovedAccessFrom: "Ufikiaji umeondolewa kwa mafanikio kutoka",
    failedToRemoveFarmAccessPleaseTryAgain: "Kushindwa kuondoa ufikiaji wa shamba. Tafadhali jaribu tena.",
    forTheFollowingUsers: "kwa mtumiaji (watumiaji) wafuatao?",
    selectFarm: "Chagua Shamba",
    grantAccess: "Ruhusu Ufikiaji",
    removeAccess: "Ondoa Ufikiaji",
    removeFarmAccess: "Ondoa Ufikiaji wa Shamba",
    farmAccessGranted: "Ufikiaji wa Shamba Umeruhusiwa",
    successfullyGrantedAccessTo: "Ufikiaji umepewa kwa mafanikio kwa",
    farm: "shamba",
    for: "kwa",
    user: "mtumiaji",
    failedToGrantFarmAccessPleaseTryAgain: "Kushindwa kutoa ufikiaji wa shamba. Tafadhali jaribu tena.",
    error: "Hitilafu",
    selectFactory: "Chagua Kiwanda",
    failedToLoadFarmsPleaseTryAgain: "Kushindwa kupakia mashamba. Tafadhali jaribu tena.",
    farmNameAndId: "Jina la Shamba na Kitambulisho",
    of: "ya",
    farmAddedBy: "Shamba Inaongezwa Na",
    exportAsCSV: "Ekspor sebagai CSV",
    activityLog: "Kumbukumbu ya Shughuli",

    youSharedAccessOfTheFarmWithTheFollowingUsersSuccessfully: "Umekidhi kushiriki ufikiaji wa shamba na mtumiaji (watumiaji) wafuatao.",
    grantAccessToMoreUsers: "Ruhusu Ufikiaji kwa Watumiaji Zaidi",
    areYouSureYouWantToRemoveAccessFor: "Je, una uhakika unataka kuondoa ufikiaji kwa",
    thisUser: "mtumiaji huyu",
    areYouSureYouWantToGrantAccessToThisFarmForTheFollowingUsers: "Je, una uhakika unataka kutoa ufikiaji kwa shamba hili kwa mtumiaji (watumiaji) wafuatao?",
    failedToLoadUsersPleaseTryAgain: "Kushindwa kupakia watumiaji. Tafadhali jaribu tena.",
    successfullyRemovedUserAccessFromThisFarm: "Ufikiaji wa mtumiaji umeondolewa kwa mafanikio kutoka shamba hili.",
    farmIdAndUserIdAreRequired: "Kitambulisho cha Shamba na Kitambulisho cha Mtumiaji vinahitajika.",
    noUsersSelectedPleaseSelectAtLeastOneUser: "Hakuna watumiaji waliochaguliwa. Tafadhali chagua angalau mtumiaji mmoja.",
    successfullyGrantedAccessToThisFarmFor: "Ufikiaji umepewa kwa mafanikio kwa shamba hili kwa",
    unknownUser: "Mtumiaji Asiyejulikana",
    confirm: "THIBITISHA",
    farmActivityLog: "Kumbukumbu ya Shughuli za Shamba",
    ipAddress: "Anwani ya IP",
    dateAndTime: "Tarehe na Muda",
    module: "Moduli",
    activityDescription: "Maelezo ya Shughuli",
    select: "Chagua",

    addNewUsers: "Ongeza Watumiaji Wapya",
    addUsersToFarm: "Ongeza Watumiaji kwa Shamba",
    selectedUsers: "Watumiaji Waliochaguliwa",
    selectTheUsersToAddInFarmFromTheBelowListOfAllUserInACooperative: "Chagua watumiaji wa kuongeza kwenye shamba kutoka kwa orodha hapa chini ya watumiaji wote katika ushirika.",
    reviewTheSelectedUsersAndAssignTheirAccessRoles: "Kagua watumiaji waliochaguliwa na uwape majukumu yao ya ufikiaji.",
    allRoles: "Majukumu Yote",
    userRegistrationDate: "Tarehe ya Usajili wa Mtumiaji",
    deactivated: "Imezimwa",
    pleaseSelectAtLeastOneUser: "Tafadhali chagua angalau mtumiaji mmoja",
    noUsersSelected: "Hakuna watumiaji waliochaguliwa",
    userRemoved: "Mtumiaji umeondolewa",
    next: "IFUATAYO",
    id: "Kitambulisho",
  },
  plantation: {
    farmerName: "Jina la Mkulima",
    phoneNumber: "Nambari ya simu",
    plantationName: "Jina la Upandaji",
    farm: "Shamba",
    location: "Mahali",
    updatePlantationStatus: "Sasisha Hali ya Upandaji miti",
    update: "UPDATE",
  },

  farma: {
    addAuser: "Ongeza Mtumiaji",
    addFarm: "Ongeza Shamba",
    addNewLocation: "Ongeza Mahali P新しい場所を追加",
    addNewUser: "Ongeza Mtumiaji Mpya",
    adduser: "Ongeza Mtumiaji",
    apply: "Tumia",
    areaUOMInfo: "Kitengo cha kupimia ukubwa wa shamba kwa mfano Hekta, Eka nk",
    calf: "Ndama",
    cancel: "Ghairi",
    certifications: "Vyeti",
    city: "Kijiji/Mji",
    cityH: "Mji ambapo shamba lipo.",
    cityInfo:
      "Makazi ya binadamu yaliyokusanyika au jamii na majengo yanayohusiana, makubwa kuliko kijiji na madogo kuliko mji, yaliyopo katika eneo la vijijini.",
    cityStatement: "Mji ambapo shamba lipo.",
    communityName: "Jina la Jamii",
    CommunityName: "Jina la Jamii",
    contractMating: "Kupandisha kwa Mkataba",
    contractMatingH:
      "Kodi ya programu ya kupandisha kwa mkataba ambayo shamba linashiriki",
    contractMatingState:
      "Kodi ya Programu ya Kupandisha kwa Mkataba ambayo Shamba Linashiriki.",
    cooperativeId: "Kitambulisho cha Ushirika/Chama",
    cooperativeIDH: "Kitambulisho cha ushirika ambacho shamba ni mwanachama",
    cooperativeName: "Jina la Ushirika/Chama",
    corporateMailingAddress: "Anwani ya Posta ya Kampuni",
    corporateName: "Jina la Kampuni",
    corporateRegistrationNum: "Nambari ya Usajili wa Kampuni",
    country: "Nchi",
    countryH: "Nchi ambapo shamba lipo.",
    countryState: "Nchi ambapo shamba lipo",
    customization: "Marekebisho",
    dam: "Bwawa",
    dataIsNotAvailableForThisFarm: "Data haipatikani kwa shamba hili",
    dateOfRegistration: "Tarehe ya Usajili",
    deleted: "Shamba limefutwa kwa mafanikio",
    deleteFarm: "Futa Shamba",
    dropHere: "au buruta na udondoshe hapa",
    editAfarm: "Hariri Shamba",
    editFarm: "Hariri Shamba",
    editUser: "Hariri Mtumiaji",
    farm_Owner: "Mmiliki wa Shamba",
    farm_type: "Aina ya Shamba",
    farmAddress: "Anwani ya Shamba",
    farmAnimals: "Wanyama wa Shamba",
    farmerFirstName: "Jina la Kwanza la Mkulima",
    farmerId: "Kitambulisho cha Mkulima",
    farmerLastName: "Jina la Mwisho la Mkulima",
    farmerMiddleName: "Jina la Kati la Mkulima",
    farmGeographicLocation: "Mahali pa Jiografia pa Shamba",
    farmID: "Kitambulisho cha Shamba",
    farmIdPlaceHolder: "Ingiza Kitambulisho cha Shamba",
    farmInformation: "Taarifa za Shamba",
    farmLatitude: "Latitudo ya Shamba",
    farmLatitudeH:
      "Ni kipimo cha umbali kaskazini au kusini mwa Ikweta. Inapimwa na mistari 180 ya kufikirika inayounda duara kuzunguka Dunia mashariki-magharibi, sambamba na Ikweta",
    farmLatitudeState: "Latitudo ya shamba",
    farmLicenseInformation: "Taarifa za Leseni ya Shamba",
    farmLocation: "Mahali pa Shamba",
    farmLocationAddressInfo:
      "Mahali ambapo shamba linafanya shughuli kuu za kilimo",
    farmLocationSize: "Mahali na Ukubwa wa Shamba",
    farmLongitude: "Longitudo ya Shamba",
    farmLongitudeH: "Inapima umbali mashariki au magharibi mwa meridiani kuu",
    farmLongitudeState: "Longitudo ya shamba",
    farmName: "Jina la Shamba",
    farmNameH: "Jina la shamba",
    farmNumber: "Nambari ya Shamba",
    farmOwner: "Mmiliki wa Shamba",
    farmOwnerH:
      "Jina la mmiliki wa shamba (jina la mkulima linaotengenezwa kiotomatiki wakati wa kuingiza taarifa)",
    farmProducts: "Bidhaa za Shamba",
    farmRegisteredProducts: "Bidhaa Zilizosajiliwa za Shamba",
    farmRegistration: "Usajili wa Shamba",
    farms: "Mashamba",
    farmsPerPage: "Mashamba kwa kila Ukurasa",
    farmStateInfo: "Anwani ya mahali pa shamba",
    farmTitleDocument: "Hati za Umiliki wa Shamba",
    farmType: "Aina ya Shamba",
    farmTypeH: "Aina ya shamba ambapo shughuli mbalimbali zinafanyika",
    geoLocation: "Mahali pa Jiografia",
    goals: "Malengo",
    govRegistrationNo: "Nambari ya Usajili wa Serikali",
    govtRegistry: "Daftari la Serikali",
    govtRegNumbH: "Nambari ya daftari ya shamba iliyotolewa na mdhibiti",
    heifer: "Ndama wa Kike",
    houseNumber: "Nambari ya Nyumba",
    houseNumberH: "Nambari ya nyumba ya shamba",
    iAmNotFarmer: "Mimi si Mkulima",
    information: "Taarifa",
    inStock: "Katika Hisa",
    licenseExpiryDate: "Tarehe ya Kuisha kwa Leseni",
    licenseExpiryDateH: "Tarehe ambayo leseni ya sasa itaisha",
    licenseExpiryDateState: "Tarehe ambayo Leseni ya sasa Inaisha",
    licenseInfo: "Taarifa ya Leseni",
    licenseNumber: "Nambari ya Leseni",
    licenseNumberH:
      "Nambari inayotambulisha leseni iliyotolewa na mdhibiti inayoihusisha na mmiliki.",
    licenseNumberState: "Nambari ya Leseni iliyotolewa na Mdhibiti",
    loadingProductsPleaseWait: "Inapakia Bidhaa... Tafadhali subiri",
    locationInfo: "Taarifa za Mahali",
    nameoftheFarm: "Jina la Shamba",
    nameOfTheFarm: "Jina la shamba",
    nextFarm: "Shamba Lijalo",
    NoAnimalsRegisteredForthisFarm:
      "Hakuna Wanyama Waliosajiliwa kwa Shamba hili",
    notDeleted: "Shamba halijafutwa.",
    ok: "sawa",
    onTheFarm: "Katika Shamba",
    ownershipType: "Aina ya Umiliki",
    ownershipTypeH:
      "Aina ya wakulima wanaomiliki/kudhibiti ardhi wanayolima na wale wasiofanya hivyo.",
    ownershipTypeState: "Aina ya Umiliki",
    perimeterLength: "Urefu wa Perimeteri",
    perimeterLengthH: "Urefu wa perimeteri ya shamba (urefu wa uzio)",
    perimeterLengthInfo: "Perimeteri Jumla ya Shamba",
    perimeterLengthState: "Urefu wa Perimeteri ya Shamba (urefu wa uzio)",
    perimeterPointLabel: "Lebo ya Nukta ya Perimeteri",
    perimeterPointLabelH:
      "Lebo ya nukta. Kwa kutumia vigezo vitatu (latitude, longitude na lebo) tunaelezea perimeteri ya shamba na kila kipande ndani ya shamba.",
    perimeterPointLabelState: "Lebo ya Nukta.",
    perimeterPointLatH: "Latitude ya nukta moja kwenye shamba",
    perimeterPointLatitude: "Latitude ya Nukta ya Perimeteri",
    perimeterPointLatitudeState: "Latitude ya nukta moja kwenye shamba.",
    perimeterPointLongH: "Longitude ya nukta moja kwenye shamba",
    perimeterPointLongitude: "Longitude ya Nukta ya Perimeteri",
    perimeterPointLongitudeState: "Longitude ya nukta moja kwenye shamba.",
    permiterUOMInfo:
      "Kitengo cha kupimia perimeteri ya shamba kwa mfano Sentimita, Mita n.k",
    plotNumber: "Nambari ya Shamba",
    plotNumberState: "Nambari ya nyumba ya shamba.",
    postal: "Kodi ya Posta/Zip",
    productCategory: "Kategoria ya Bidhaa",
    productionSystem: "Mfumo wa Uzalishaji",
    productionSystemH: "Mfumo gani wa uzalishaji unatumika kwenye shamba",
    productionSystemNew: "Mfumo wa Uzalishaji",
    productionSystemState: "Mfumo wa Uzalishaji unaotumika katika Shamba",
    productionType: "Aina ya Uzalishaji",
    productName: "Jina la Bidhaa",
    products: "Bidhaa",
    provinceStateInfo: "Mgawanyo mkuu wa kiutawala wa nchi au himaya.",
    recordsPerpage: "Rekodi kwa Ukurasa",
    register: "Sajili",
    registerAfarm: "Sajili Shamba",
    registerAnAnimal: "Sajili Mnyama",
    registerAProduct: "Sajili Bidhaa",
    registerNewProduct: "Sajili Bidhaa Mpya",
    registration: {
      CommunityName:
        "Jina lililopewa kundi la watu wenye sifa au maslahi ya pamoja wanaoishi pamoja ndani ya jamii kubwa",
      farmID: "Nambari ya Utambulisho iliyopewa shamba la mifugo",
      farmName: "Jina lililopewa shamba la mifugo",
      farmOwner: "Mtu yeyote anayemiliki au kudhibiti operesheni za shamba",
      farmType:
        "Aina ya shamba inaweza kugawanywa (kukusanywa) kulingana na mifugo iliyolimwa na jinsi ilivyolimwa",
      govtRegistrationNumber:
        "Nambari iliyotolewa na shirika la serikali ambalo shamba limesajiliwa",
      licenseExpiryDate: "Siku ambayo leseni inakuwa batili kwa utambuzi",
      licenseNumber: "Nambari ya leseni iliyotolewa na mdhibiti",
      ownershipType:
        "Aina ya wakulima wanaomiliki/kudhibiti shamba na wale wasiofanya hivyo",
      perimeterPointLabel:
        "Lebo ya nukta. Kwa kutumia vigezo vitatu (latitude, longitude na lebo) tunaelezea perimeteri ya shamba na kila kipande ndani ya shamba.",
      perimeterPointLatitude: "Latitude ya nukta ya perimeteri",
      perimeterPointLongitude: "Longitude ya nukta ya perimeteri",
      regulatorName: "Jina la mdhibiti ambaye alitoa leseni",
      regulatorRepresentativeName: "Jina la Mwakilishi wa Mdhibiti",
    },
    regularFarms: "Mashamba ya Kawaida",
    regularNameH: "Jina la mdhibiti ambaye alitoa leseni",
    regularRepName: "Jina la mtu anayewakilisha mdhibiti aliyetoa leseni",
    regulatorName: "Jina la Mdhibiti",
    regulatorNameState: "Jina la mdhibiti ambaye alitoa leseni",
    regulatorRepresentativeName: "Jina la Mwakilishi wa Mdhibiti",
    regulatorRepresentativeNameState:
      "Jina la mtu anayewakilisha mdhibiti aliyetoa leseni",
    restoreDefault: "Rejesha Chaguo-msingi",
    searchByFarmNameAndId: "Tafuta kwa Jina la Shamba na Id",
    searchByProductName: "Tafuta Kwa Jina la Bidhaa",
    searchState:
      "Tafuta kwa ID ya Shamba, Usajili wa Serikali, ID ya Ushirika, Aina ya Shamba, Kupandisha kwa Mkataba",
    selectDept: "Chagua Idara",
    selectRole: "Chagua Wajibu",
    sire: "Baba wa Kizazi",
    state: "Mkoa",
    stateH: "Mkoa wa nchi ambapo shamba liko.",
    stateStatement: "Mkoa wa nchi ambapo shamba liko.",
    steer: "Ng'ombe Dume",
    stockStatus: "Hali ya Hisa",
    street: "Mtaa",
    streetH: "Jina la mtaa wa shamba.",
    streetNumberInfo: "Nambari ya Mtaa",
    streetStatement: "Jina la mtaa wa shamba.",
    technicianName: "Jina la Fundi",
    totalFarms: "Jumla ya Mashamba",
    totalFarmSize: "Ukubwa Jumla wa Shamba",
    totalFarmSizeH:
      "Ukubwa wa shamba ni jumla ya ardhi ambayo kwa sasa inalimwa na shamba ikiwa ni pamoja na ardhi chini ya mapumziko lakini isipokuwa ardhi chini ya mimea asilia, miti au malisho.",
    totalFarmSizeInfo: "Ukubwa Jumla wa Shamba",
    totalFarmSizeState: "Ukubwa wa Shamba",
    update: "Sasisha",
    uploadUsers: "Pakia Watumiaji",
    userRoles: "Majukumu ya Mtumiaji",
    zones: "Zoni",
    gpsLocation: "Mahali kwa GPS",
    latitude: "Umbali wa Kusini",
    longitude: "Umbali wa Mashariki",
  },
};
